module.exports = __webpack_public_path__ + "img/frxxkr-currency-guide-1.f5aaf631.jpg";